<template>
  <portal :to="portalTo">
    <div
      :id="id"
      class="rich-popover-root"
    >
      <slot />
    </div>
  </portal>
</template>

<script>
export default {
  name: 'RichPopover',
  props: {
    id: {
      type: String,
      default: 'rich-popover',
    },
    portalTo: {
      type: String,
      default: 'popover-portal',
    },
  },
}
</script>

<style scoped lang="scss">
@import '@/styles/material-dashboard/variables.scss';

.rich-popover-root {
  display: none;
  position: absolute;
  background: $background-paper;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  padding: 16px;
  width: max-content;

  &::before,
  &::after {
    content: '';
    position: absolute;
    bottom: -23px;
    left: 50%;
    transform: translateX(-50%);
    border-width: 12px;
    border-style: solid;
    border-color: $background-paper transparent transparent transparent;
  }
  &::before {
    filter: blur(1px);
    bottom: -24px; /* One pixel lower than the arrow */
    border-color: rgba(0, 0, 0, 0.08) transparent transparent transparent;
  }
}
</style>

<!-- DOCUMENTATION --

This component acts as a shell for popover content. Pass content via slot.

-->